import { cva } from 'class-variance-authority';

const tabsBaseBaseStyles = ['text-sm', 'font-medium'];

const tabsBaseStylesSAG = cva([
  ...tabsBaseBaseStyles,
  'text-[#000028]',

  'dark:text-white',
]);

const tabsBaseStylesSHS = cva([
  ...tabsBaseBaseStyles,
  'text-[#666666]',

  'dark:text-[#999999]',
]);

export { tabsBaseStylesSAG, tabsBaseStylesSHS };
